<div
  class="w-75 w-lg-50 h-100 container d-flex justify-content-center align-items-center flex-column"
>
  <form
    [formGroup]="passwordFormGroup"
    (ngSubmit)="onSubmitPasswordForm()"
    class="row g-0 justify-content-start"
  >
    <input
      [disabled]="submit"
      formControlName="newPassword"
      type="password"
      placeholder="password"
      [ngClass]="
        passwordFormGroup.get('newPassword').errors ? 'error' : 'success'
      "
      class="col-10 mb-2 rounded ps-1"
    />
    <input
      [disabled]="submit"
      formControlName="retypeNewPassword"
      type="password"
      placeholder="retype password"
      [ngClass]="
        passwordFormGroup.get('retypeNewPassword').errors ||
        passwordFormGroup.invalid
          ? 'error'
          : 'success'
      "
      class="col-10 ms-0 rounded ps-1"
    />
    <div class="btn-group mt-2 w-50">
      <button
        class="btn btn-primary ms-0 text-white rounded"
        [disabled]="submit || passwordFormGroup.invalid"
        type="submit"
      >
        Save
      </button>
      <button (click)="backToCodeForm()" class="btn btn-light ms-2 rounded">
        Back
      </button>
      <div *ngIf="errorMsg.length">{{ errorMsg }}</div>
    </div>
  </form>
</div>
